import { render, staticRenderFns } from "./qylink.vue?vue&type=template&id=e48ad95c&scoped=true"
import script from "./qylink.vue?vue&type=script&lang=js"
export * from "./qylink.vue?vue&type=script&lang=js"
import style0 from "./qylink.vue?vue&type=style&index=0&id=e48ad95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48ad95c",
  null
  
)

export default component.exports